<template>
  <component :is="MARKEY_CARD[type]" :item="item" :firstSelectItem="firstSelectItem"></component>
</template>

<script setup lang="ts">
  import { MARKET_TYPE } from '../contsants';
  import Activity from './activity.vue';
  import Product from './product.vue';
  import Default from './default.vue';
  import Article from './article.vue';

  defineProps<{
    type: MARKET_TYPE;
    item: any;
    firstSelectItem: any;
  }>();
  const MARKEY_CARD = {
    [MARKET_TYPE.SEND_ACTIVITY]: Activity,
    [MARKET_TYPE.SEND_PRODUCT]: Product,
    [MARKET_TYPE.SEND_ARTICLE]: Article,
    [MARKET_TYPE.SEND_POSTER]: Default,
    [MARKET_TYPE.SEND_MOMENTS]: Default,
    [MARKET_TYPE.SEND_FESTIVAL_CARE]: Default,
  };
</script>

<style scoped></style>
